<div class="container card positionCard main-card">
    <div class="row">
        <div class="col-md-7 col-md-offset-3 col-sm-10 col-sm-offset-1 card-size-padding">
            <div class="clearfix no-gutter-sm contentpop-block">
                <div class="center-block">
                    <div class="mobTab">
                        <div class="content-box clearfix">
                            <div class="row">
                                <div class="col-xs-12 text-center success-block top-pad-20">
                                    <p class="mobile-number">Your application is already open in another tab, please
                                        continue existing application</p>
                                    <div class="divider-line top-spc-20 line-margin line-spec"></div>
                                    <hr class="dashed">
                                    <offer-add [addLocation]="'multitab'" [ProdType]="ProdType"></offer-add>
                                    <div class="row top-spc-20 bottom-margin-30">
                                        <button id="confirmOtp_next" class="btn btn-block btnconfirm"
                                            (click)="ExploreMore()">
                                            <span>Explore More</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>